import b from 'b_';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React from 'react';

import Input from '../input/input';
import Text from '../text/text';

import { attributeFilterPropType } from './utils';

// TODO стилизовать, когда появятся числовые фильтры

class AttributeFilterTypeNumber extends React.Component {
    static propTypes = {
        filter: attributeFilterPropType,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    };

    onChange = ({ target: { value } }) => {
        const { onChange } = this.props;

        onChange(value === '' ? undefined : value);
    };

    render() {
        const { filter, value } = this.props;

        return (
            <div className={b('attribute', 'filter', { type: 'number' })}>
                <div className="attribute__filter-title">
                    <Text weight={Text.WEIGHT.M}>{filter.name}</Text>
                </div>
                <Input onChange={this.onChange} type="number" value={value} />
            </div>
        );
    }
}

export default React.memo(AttributeFilterTypeNumber, (prevProps, nextProps) => {
    return isEqual(prevProps.filter, nextProps.filter) && isEqual(prevProps.value, nextProps.value);
});
